export default __webpack_public_path__ + "static/media/new_custome.2f93c9d2.png";